import { success, failure, request } from 'app/actions';
import * as actions from './addProfileActions';
import moment from 'moment';
import { concat, first } from 'lodash';

const initialState = {
  profile: {},
  schools: [],
  roles: [],
  evaluations: [],
  catalogings: [],
  isLoading: false,
  hasError: false,
  apiError: null,
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.RESET_ADD_PROFILE:
      return {
        ...initialState,
      };
    case request(actions.ADD_TEACHER):
    case request(actions.GET_SCHOOLS):
    case request(actions.GET_PROFILE):
    case request(actions.GET_PROFILES_TYPES):
    case request(actions.GET_EVALUATIONS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
        apiError: null,
        success: false,
      };
    case success(actions.GET_SCHOOLS):
      const schools = action.payload.content.map(s => ({
        ...s,
        value: s.idCSchool,
        label: s.name,
      }));
      return {
        ...state,
        schools,
        isLoading: false,
      };
    case success(actions.GET_PROFILE):
      return {
        ...state,
        profile: action.payload.profile,
        isLoading: false,
      };
    case failure(actions.GET_SCHOOLS):
      return {
        ...state,
        schools: [],
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case success(actions.GET_PROFILES_TYPES):
      return {
        ...state,
        roles: action.payload.content,
        isLoading: false,
      };
    case success(actions.GET_FILTERED_CATALOGINS):
      const catalogings = action.payload.contents.map(c => ({ ...c, value: c.id, label: c.name }));
      return {
        ...state,
        catalogings,
        isLoading: false,
      };
    case failure(actions.GET_PROFILES_TYPES):
      return {
        ...state,
        roles: [],
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case success(actions.GET_EVALUATIONS):
      const evaluations = action.payload.content.map(e => {
        let levelSegment = '';

        if (e.levelSegment.length === 1) {
          levelSegment = first(e.levelSegment);
        } else {
          levelSegment = e.levelSegment.join('; ');
        }

        const catalogings =
          e.catalogings.length === 1
            ? e.catalogings[0].name
            : e.catalogings.map(c => c.name).join('; ');
        const label = `${catalogings} - ${e.application}`;
        const labelWithDate = e.date
          ? `${levelSegment} - ${label} - ${moment(e.date).format('DD/MM/Y')}`
          : `${levelSegment} - ${label}`;
        return {
          ...e,
          value: e.id,
          label: labelWithDate,
        };
      });
      return {
        ...state,
        evaluations,
        isLoading: false,
      };
    case failure(actions.GET_PROFILE):
      return {
        ...state,
        profile: {},
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case failure(actions.GET_EVALUATIONS):
      return {
        ...state,
        evaluations: [],
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case failure(actions.GET_FILTERED_CATALOGINS):
      return {
        ...state,
        catalogings: [],
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case failure(actions.ADD_TEACHER):
      return {
        ...state,
        isLoading: false,
        hasError: true,
        apiError: action.payload.error,
      };
    case success(actions.ADD_TEACHER):
    case success(actions.EDIT_TEACHER):
      return {
        ...state,
        success: true,
        isLoading: false,
        hasError: false,
      };
    default:
      return state;
  }
};

export default reducer;
